export enum PdfViewMode {
  DEFAULT,
  FIT_TO_WIDTH,
  FIT_TO_HEIGHT,
}
